module.exports = __webpack_public_path__ + "img/send.0d740fec.svg";